export enum ExportTypesEnum {
  invoice = 'invoice',
  estimate = 'estimate',
  credit_memo = 'credit_memo',
  purchase_order = 'purchase_order',
  client = 'client',
  item = 'item',
  expense = 'expense',
  tracked_time = 'tracked_time',
  appointment = 'appointment',
}

export const EXPENSE_REPORT_EXPORT_ACCEPT_VERSION = '1.0.0';
export const EXPORT_ACCEPT_VERSION = '5.0.0';
